import React from 'react';
import MediaQuery from 'react-responsive';
import Avatar from '@influitive/secret-garden/lib/avatar';
import { withNamespaces } from 'react-i18next';
import cn from 'classnames';

import styles from './style.css';
import avatarPng from '../../assets/default_image.png';

export const Placeholder = withNamespaces()(({ t }) => (
  <React.Fragment>
    <MediaQuery minWidth={769}>
      <React.Fragment>
        <div className={cn(styles.placeholder, 'c-placeholder-container')}>
          <Avatar
            size={'small'}
            url={avatarPng}
            alt={t('Avatar Placeholder')} />
        </div>
        <div className={cn(styles.bannerPlaceholder, 'c-placeholder-banner')}/>
      </React.Fragment>
    </MediaQuery>
    <MediaQuery maxWidth={768}>
      <div className={cn(styles.mobilePlaceholder, 'c-placeholder-mobile')}/>
    </MediaQuery>
  </React.Fragment>
));

export const UnauthPlaceholder = () => (
  <React.Fragment>
    <MediaQuery minWidth={769}>
      <div className={cn(styles.unauthDesktop, 'c-unauth-desktop')}></div>
    </MediaQuery>
    <MediaQuery maxWidth={768}>
      <div className={cn(styles.mobilePlaceholder, 'c-placeholder-mobile')}></div>
    </MediaQuery>
  </React.Fragment>
);
